// FIXED Sidebar.js - sidebar headers overlay main header
import React from "react";
import { Box, Slide } from "@mui/material";

const Sidebar = ({
  open,
  onClose,
  side = "left",
  width = 280,
  header,
  children,
  topOffset = 0,
}) => {
  return (
    <Slide
      direction={side === "left" ? "right" : "left"}
      in={open}
      timeout={300}
      mountOnEnter
      unmountOnExit
    >
      <Box
        data-sidebar
        sx={{
          position: "absolute",
          // top: topOffset >= 0 ? `${topOffset}px` : 0,
          top: "10px",
          [side]: 0,
          height: topOffset >= 0 ? `calc(100% - ${topOffset}px)` : "100%",
          width: width,
          backgroundColor: "#fff",
          borderRight: side === "left" ? "1px solid #e0e0e0" : "none",
          borderLeft: side === "right" ? "1px solid #e0e0e0" : "none",
          boxShadow:
            side === "left"
              ? "2px 0 8px rgba(0,0,0,0.08)"
              : "-2px 0 8px rgba(0,0,0,0.08)",
          zIndex: 20, // Higher than main header (15) so entire sidebar overlays
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          // Apply negative topOffset as transform to move the entire sidebar up
          ...(topOffset < 0 && {
            transform: `translateY(${topOffset}px)`,
          }),
        }}
      >
        {/* Header - positioned to overlay main header */}
        {header && (
          <Box
            sx={{
              height: "73px",
              minHeight: "73px",
              maxHeight: "73px",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fafafa",
              borderBottom: "1px solid #e0e0e0",
              flexShrink: 0,
              overflow: "hidden",
              position: "absolute", // Position absolutely
              top: topOffset < 0 ? "0px" : "0px", // When topOffset is -73, header should be at top (0px) to overlay main header
              left: 0,
              right: 0,
              zIndex: 30, // Very high z-index to overlay main header
            }}
          >
            {header}
          </Box>
        )}

        {/* Content - with top margin to account for absolutely positioned header */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            marginTop: header ? "73px" : "0px", // Push content down to make room for absolute header
          }}
        >
          {children}
        </Box>
      </Box>
    </Slide>
  );
};

export default Sidebar;
